import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";

export default {

    /**
     * @param   Object data
     * - bizId
     * - bizType
     * @param   Function callback
     */
    addFavorite : function(data, callback) {
        requestManager.request({
            url: 'portal/v4/user/center/collection/collect',
            method : 'POST',
            data: data
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback();
        });
    },

    /**
     * @param   Object data
     * - bizId
     * @param   Function callback
     */
    cancelFavorite : function(data, callback) {
        requestManager.request({
            url: 'portal/v4/user/center/collection/cancel',
            method : 'DELETE',
            data: data
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback();
        });
    },

    /**
     * @param   Object data
     * - bizId
     * @param   Function callback
     */
    isFavorite : function(data, callback) {
        requestManager.request({
            url: 'portal/v4/user/center/collection/isCollect',
            data: data
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    },


};
